<template>
  <div class="edit-platform">
    <!--标题-->
    <!-- <div class="breadcrumb" style="background: #fff">申请平台</div> -->
    <!-- <div class="third-title"><span>基础信息</span></div> -->
    <div class="order-detail-basic">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
        <el-form-item label="平台号:" prop="num">
          <el-autocomplete v-model="code" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect">
          </el-autocomplete>
          <el-button @click="verifyStore" style="margin-right:10px" round>验证平台</el-button>
          <span v-show="show">平台名称:{{ storeName }}</span>
        </el-form-item>
        <el-form-item label="产品名称:" prop="nameProd">
          <!-- <el-input v-model="ruleForm.name" maxlength="20"></el-input> -->
          <el-autocomplete popper-class="prodName" v-model="ruleForm.nameProd" :fetch-suggestions="querySearchProd" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelectProd"
            style="min-width: 300px;">
          </el-autocomplete>
        </el-form-item>
        <!-- 非套系产品循环产品属性 -->
        <div v-if="!isObjectEmpty(spuDetail.dict)">
          <div class="tecol" v-for="(dictValList, dictKey) in spuDetail.dict" :key="dictKey">
            <i>{{ dictKey }}:</i>
            <el-radio-group @change="val => change(val, dictKey)" v-model="ruleForm.dict[dictKey]">
              <el-radio-button :class="dictVal.disabled ? 'asd' : ''" :disabled="isStart" :label="dictVal" v-for="dictVal in dictValList" :key="dictVal.val"> {{ dictVal.val }} </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <!-- 套系产品 循环产品属性-->
        <div class="tecol" v-if="isObjectEmpty(spuDetail.dict) && spuDetail.skuGroupList">
          <i>选择套系:</i>
          <el-radio-group v-model="skuGroup" @change="changeGroup">
            <el-radio-button :label="item" v-for="item in spuDetail.skuGroupList" :key="item.id" :disabled="isStart" style="margin-left:5px;">{{ item.skuGroupName }}</el-radio-button>
          </el-radio-group>
        </div>
        <el-form-item label="主题:" prop="sampleSkuId">
          <el-select clearable v-model="ruleForm.sampleSkuId" placeholder="请选择主题" @change="previewImg">
            <el-option v-for="item in confirmSku.sampleSkuList" :key="item.id" :label="item.skuName" :value="item.id"></el-option>
          </el-select>
          <el-button @click="showPreviewImg" style="margin-left:20px" round>预览</el-button>
          <el-button @click="downloadPdf" style="margin-left:20px" round>下载缩略图</el-button>
        </el-form-item>
        <el-form-item label="样品价格:" prop="samplePrice">
          <span>{{ ruleForm.samplePrice }}</span>
        </el-form-item>
        <el-form-item label="数量:" prop="quantity">
          <el-input v-model="ruleForm.quantity" @input="quantityInput"></el-input>
        </el-form-item>
        <el-form-item label="支付价格:" prop="payPrice">
          <el-input v-model="ruleForm.payPrice"></el-input>
        </el-form-item>
        <el-form-item label="省/地市/区县:" class="is-required" prop="address">
          <el-select v-model="selectAddress.sheng" value-key="code" @change="selectAddress.shi = '', selectAddress.qu = '', getAllshi()" clearable>
            <el-option v-for="(option, index) in address.sheng" :key="'provinces' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
          <el-select v-model="selectAddress.shi" value-key="id" @change="selectAddress.qu = '', getAllQu()" clearable style="margin-left: 5px;">
            <el-option v-for="(option, index) in address.shi" :key="'city' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
          <el-select v-model="selectAddress.qu" value-key="id" clearable style="margin-left: 5px;">
            <el-option v-for="(option, index) in address.qu" :key="'region' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址:" prop="addressVo" class="is-required">
          <el-input v-model="ruleForm.addressVo.fullAddress" style="width: 400px" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="联系人:" prop="person">
          <el-input v-model="ruleForm.person" :readonly="false"></el-input>
        </el-form-item>
        <el-form-item label="电话:" prop="phone">
          <el-input v-model="ruleForm.phone" :readonly="false"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input v-model="ruleForm.remark"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="openSave('cart')" v-preventReClick v-if="spuDetail.isSeries === false">加入购物车</el-button>
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="openSave('order')" v-preventReClick>提交订单</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" title="申请样品" :visible.sync="dialogVisible" width="30%">
      <div>
        <p>当前充值余额：￥{{ basicMsg.myBalance }}</p>
        <p>申请样品金额：￥{{ ruleForm.payPrice }}</p>
        <p>剩余金额：￥{{ basicMsg.balance }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false, loading = false">取 消</el-button>
        <el-button type="primary" @click="applySample" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 轮播（预览） -->
    <el-dialog :visible.sync="imgViewerVisible" width="60%" class="dialog" v-if="imgViewerVisible" :fullscreen="isFull" :showClose="false">
      <template slot="title">
        <div style="display:flex; justify-content:space-between;">
          <div>{{ itemImgs.name }}</div>
          <div style="display:flex;">
            <img src="../../../assets/images/page-big.png" width="18px" alt="" @click="isFull = true" v-if="!isFull" />
            <img src="../../../assets/images/page-small.png" width="18px" alt="" @click="isFull = false" v-else />
            <img src="../../../assets/images/close.png" width="18px" alt="" style="margin-left:20px;" @click="imgViewerVisible = false" />
          </div>
        </div>
      </template>
      <div style="text-align: center;width: 100%;">{{ itemImgs.index }}/{{ imageList.length }}</div>
      <div class="dialog-box">
        <div class="switch-btn" @click="onClickCarousel('prev')"><img src="../../../assets/images/carousel-left.png" width="30" /></div>
        <el-carousel :interval="5000" arrow="never" class="switch-box" :indicator-position="'none'" ref="el-carousel" :loop="false" :autoplay="false" height="400px" @change="carouselChange">
          <!-- <el-carousel-item class="switch" v-if="!isOneLoad"><img :src="UserLookList[0].thumbnailUrl + '?x-sds-process=image/resize,l_160,m_mfit'" @load="changeLoad" />
              </el-carousel-item> -->
          <el-carousel-item v-for="(item, index) in imageList" :key="index" class="switch"><img :src="item.imageUrl" />
          </el-carousel-item>
        </el-carousel>
        <div class="switch-btn" @click="onClickCarousel('next')"><img src="../../../assets/images/carousel-right.png" width="30" /></div>
      </div>
      <!-- <div class="dialog-btn"><p class="submit" @click="onSubmit" v-if="detailOrder.totalOprt === detailOrder.totalCustomer">确认</p> </div> -->
    </el-dialog>
  </div>
</template>
<script>
import { storeTypeGetStoreTypeList, storeUsable, storeApplyStore, addressGetCountyByCityId, addressGetCityByProvinceCode, addressGetAllProvince, storeQueryListByCode, storeQueryByStoreCode, saveUserAddress } from '@/api/crm'
import { getByStoreIds } from '@/api/epay'
import { previewSampleImage, spuListSpu, storeSpuQuery } from '@/api/pms'
import { orderNow, cartItemSpu } from '@/api/oms'
import uploadWebImg, { getAwsSdk, uploadStr } from '@/utils/uploadWebImg'
import JsPDF from 'jspdf'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
export default {
  name: 'edit-platform',
  data () {
    return {
      openType: '',
      storeType: '',
      startups: 0,
      isFull: false,
      itemImgs: {
        name: '',
        index: 0
      },
      // 授信额度
      standbyCreditLine: 0,
      basicMsg: { balance: '', mybalance: '' },
      code: '',
      imageList: [],
      show: false,
      storeName: '',
      imgViewerVisible: false,
      index: 0,
      spuDetail: {},
      ruleForm: {
        myBalance: '',
        quantity: 0,
        payPrice: '',
        dict: {},
        isSample: false,
        sampleSkuId: '',
        addressVo: {
          city: '',
          cityId: '',
          county: '',
          countyId: '',
          fullAddress: '',
          id: '',
          province: '',
          provinceCode: ''
        },
        person: '',
        phone: null,
        remark: ''
      },
      skuGroup: {
        sampleSkuList: []
      },
      isStart: false,
      confirmSku: {
        sampleSkuList: []
      },
      loading: false,
      address: {
        sheng: [],
        shi: [],
        qu: []
      },
      selectAddress: {
        sheng: {
          name: ''
        },
        shi: {
          name: ''
        },
        qu: {
          name: ''
        }
      },
      // ----------之前的----------
      applySuccessDialog: false,
      dialogVisible: false,
      awsSdk: null,
      rules: {
        payPrice: [{
          required: true,
          message: '请输入支付价格',
          trigger: 'blur'
        }],
        sampleSkuId: [
          {
            required: true,
            message: '请选择主题',
            trigger: 'blur'
          }
        ],
        nameProd: [{
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        }],
        phone: [
          {
            required: true,
            message: '请填写手机号',
            trigger: 'blur'
          },
          {
            validator: this.$FormRules.checkPhone,
            trigger: 'blur'
          }
        ],
        person: [
          {
            required: true,
            message: '请填写联系人',
            trigger: 'blur'
          }
        ],
        storeTypeid: [
          {
            required: true,
            message: '请选择平台类型',
            trigger: 'change'
          }
        ],
        companyName: [
          {
            min: 1,
            max: 20,
            message: '长度不能超过20个字符',
            trigger: 'blur'
          }
        ],
        platformTypeid: [{
          required: true,
          message: '请选择平台类型',
          trigger: 'change'
        }],
        sendFlag: [{
          required: true,
          message: '发货目的地:',
          trigger: 'change'
        }]
      },
      platformType: [],
      storeMsg: {}
    }
  },
  watch: {
    skuGroup: {
      handler (val, oldVal) {
        console.log('val', val, 'oldVal', oldVal)
        this.confirmSku = val
        // this.ruleForm.samplePrice = this.confirmSku.samplePrice
        this.ruleForm.samplePrice = ((this.startups == 1 && this.storeType == 'WEDDINGDRESS' && this.ruleForm.startupsSpu) || this.storeType == 'LATERSTAGE') ? this.confirmSku.startupsSamplePrice : this.applyDiscount ? (this.confirmSku.samplePrice * this.applyDiscount).toFixed(2) : this.confirmSku.samplePrice
        // this.ruleForm.payPrice = this.confirmSku.samplePrice
        // this.ruleForm.payPrice = ((this.startups == 1 && this.storeType == 'WEDDINGDRESS' && this.ruleForm.startupsSpu) || this.storeType == 'LATERSTAGE') ? this.confirmSku.startupsSamplePrice : this.applyDiscount ? this.confirmSku.samplePrice * this.applyDiscount : this.confirmSku.samplePrice
        this.ruleForm.onlineSamplePrice = this.applyDiscount ? (this.confirmSku.onlineSamplePrice * this.applyDiscount).toFixed(2) : this.confirmSku.onlineSamplePrice
        this.ruleForm.sampleSkuId = ''
        if (this.confirmSku.sampleSkuList[0].id) {
          this.ruleForm.sampleSkuId = this.confirmSku.sampleSkuList[0].id
          this.ruleForm.quantity = 1
          this.ruleForm.payPrice = (this.ruleForm.samplePrice * this.ruleForm.quantity).toFixed(2)
        }
        let skuGroupId = this.confirmSku.id
        if (skuGroupId === '') {
          this.confirmSku = {
            sampleSkuList: []
          }
          this.isShow = false
        } else {
          this.isShow = true
          this.ruleForm.isSample = false
        }
        this.$forceUpdate()
        // this.$refs.bigP.changeSkuGroupImg(val.skuGroupImage)
        // this.selectedList.sampleSkuId = val.sampleSkuList[0]
        // if (this.selectedList.skuGroup.sampleSkuList.length === 0) {
        //   this.selectedList.isSample = false
        // }
      },
      deep: true,
      immediate: false
    }
  },
  created () {
    this.getAllSheng()
    if (this.$checkAwsSdk('special')) {
      this.$store.dispatch('awsSdk/getAwsSdk', 'special')
    }
    storeTypeGetStoreTypeList().then((res) => {
      this.platformType = res.data.data
    })
  },
  methods: {
    // 下载缩略图
    async downloadPdf () {
      if (this.confirmSku.sampleSkuList.length < 1) {
        this.$message.error('该产品没有样品主题，请添加')
        return
      }
      if (!this.skuListData || this.skuListData.length === 0) {
        this.$message.error('该主题没有样片，请上传')
        return
      }
      this.Loading = this.$loading({
        lock: true,
        text: '正在下载，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        const zip = new JSZip()
        for (let i = 0; i < this.skuListData.length; i++) {
          const imageList = this.skuListData[i].imageList
          // this.currentStatus = `正在处理: ${image.name} (${i + 1}/${this.images.length})`

          // 生成PDF
          const pdf = await this.imageToPdf(imageList)

          // 添加到ZIP
          const pdfName = this.skuListData[i].skuFrontName + '.pdf'
          zip.file(pdfName, pdf.output('blob'))
        }
        // 生成ZIP文件
        const zipBlob = await zip.generateAsync({ type: 'blob' })
        // 触发下载
        let zipName = this.ruleForm.nameProd
        saveAs(zipBlob, zipName)
        this.$message.success('下载完成')
        this.Loading.close()
      } catch (error) {
        console.error('生成PDF失败:', error)
        this.$message.error('下载失败，请联系管理员或重试')
      }
    },
    async imageToPdf (imageList) {
      console.log('this.imageList', imageList)
      try {
        // const title = name // 定义下载的PDF文件名
        // 创建JsPDF实例，方向为竖屏，单位毫米，A4尺寸
        // const PDF = new JsPDF('p', 'mm', 'a4')
        let PDF = null
        // 使用Promise.all确保所有图片处理完成
        const imgPromises = imageList.map(item => this.getImgInfo((item.imageUrl + '?x-sds-process=image/resize,l_500,m_mfit')))
        const imgDataList = await Promise.all(imgPromises)
        // 遍历处理好的图片数据，添加到PDF中
        imgDataList.forEach((imgData, index) => {
          console.log('imgData', imgData)
          // 设置PDF单位为像素（px）
          let format = [imgData.imgWidth, imgData.imgHeight]
          const orientation = imgData.imgWidth > imgData.imgHeight ? 'landscape' : 'portrait'
          // if (imgData.imgWidth > imgData.imgHeight) {
          //   format = [imgData.imgWidth, imgData.imgHeight]
          // } else {
          //   format = [imgData.imgHeight, imgData.imgWidth]
          // }
          if (index === 0) {
            // 第一张图片，创建PDF文档，页面尺寸就是这张图片的尺寸
            PDF = new JsPDF({
              format: format,
              unit: 'mm',
              orientation: orientation
            })
            // 将图片添加到首页，从(0,0)开始，占满页面
            PDF.addImage(imgData.img, 'PNG', 0, 0, imgData.imgWidth, imgData.imgHeight)
          } else {
            console.log('orientation', orientation)
            // 后续图片，先添加一个与图片同尺寸的新页面
            PDF.addPage(format, orientation)
            // 切换到新页面（jsPDF内部会自动切换焦点到新页）
            // 在新页面上添加图片，从(0,0)开始，占满页面
            PDF.addImage(imgData.img, 'JPEG', 0, 0, imgData.imgWidth, imgData.imgHeight)
          }
          // if (index > 0) {
          //   // 从第二张图片开始，为每张图片创建一个新页面
          //   PDF.addPage()
          // }
          // // 将图片添加到PDF页面的左上角 (x=0, y=0)，并设置计算好的宽高
          // PDF.addImage(
          //   imgData.img,
          //   'JPEG',
          //   0,
          //   0,
          //   imgData.imgWidth,
          //   imgData.imgHeight
          // )
        })
        // 保存并下载PDF文件
        // PDF.save(title + '.pdf')
        return PDF
      } catch (error) {
        console.error('生成PDF失败:', error)
        alert('生成PDF失败，请重试或检查图片链接。')
      }
    },
    // 工具函数：获取图片信息并计算在PDF中的尺寸
    getImgInfo (src) {
      return new Promise((resolve, reject) => {
        // A4纸尺寸 (单位: mm), 长宽比
        const a4Width = 210
        const a4Height = 297
        const a4Ratio = a4Height / a4Width // A4纸长宽比

        const img = new Image()
        img.src = src
        img.onload = () => {
          const imgRatio = img.height / img.width
          let imgWidth, imgHeight
          // 根据图片与A4纸的比例关系，调整图片在PDF中的尺寸
          if (imgRatio > a4Ratio) {
            // 图片比较高，高度方向填满，宽度按比例缩放
            imgHeight = a4Height
            imgWidth = a4Height / imgRatio
          } else {
            // 图片比较宽或比例接近，宽度方向填满，高度按比例缩放
            imgWidth = a4Width
            imgHeight = a4Width * imgRatio
          }
          // const imgWidth = img.width
          // const imgHeight = img.height
          resolve({
            img: img,
            imgWidth: imgWidth,
            imgHeight: imgHeight
          })
        }
        img.onerror = reject
      })
    },
    quantityInput () {
      this.ruleForm.payPrice = (this.ruleForm.samplePrice * this.ruleForm.quantity).toFixed(2)
    },
    // 判断是不是空对象
    isObjectEmpty (obj) {
      if (JSON.stringify(obj) === '{}') {
        return true
      } else {
        return false
      }
    },
    // 验证平台
    verifyStore () {
      if (!this.code) {
        this.$message.error('请输入平台号')
        return
      }
      storeQueryByStoreCode(this.code).then(async res => {
        if (res.data.data.exist) {
          // if (res.data.data.auditStatus !== 'HANDLE') {
          //   this.$message.error('平台未审核')
          //   return
          // }
          // 重新选择平台之后清空数据局
          this.ruleForm = {
            myBalance: '',
            quantity: 0,
            payPrice: '',
            dict: {},
            isSample: false,
            sampleSkuId: '',
            addressVo: {
              city: '',
              cityId: '',
              county: '',
              countyId: '',
              fullAddress: '',
              id: '',
              province: '',
              provinceCode: ''
            },
            person: '',
            phone: null,
            remark: ''
          }
          this.spuDetail = {}
          let address = res.data.data.address
          this.storeType = res.data.data.storeType
          this.startups = res.data.data.startups
          this.ruleForm.storeId = res.data.data.id
          this.storeName = res.data.data.name
          this.applyDiscount = res.data.data.applyDiscount
          this.show = true
          this.selectAddress.sheng = {
            code: address.provinceCode,
            countryCode: 'CN',
            name: address.province
          }
          this.selectAddress.shi = {
            id: address.cityId,
            code: address.cityId.toString(),
            name: address.city
          }
          this.selectAddress.qu = {
            id: address.countyId,
            code: address.countyId.toString(),
            name: address.county
          }
          await this.getAllshi()
          this.ruleForm.addressVo.fullAddress = address.completeAddress
          this.ruleForm.person = address.person
          this.ruleForm.phone = this.$msg.filterBridal(address.phone)
        } else {
          this.$message.error('平台不存在')
        }
      })
    },
    handleSelect (item) {
      this.ruleForm.storeId = ''
      this.storeName = ''
      this.show = false
    },
    querySearchAsync (queryString, cb) {
      storeQueryListByCode(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    // 产品名称搜索
    querySearchProd (queryString, cb) {
      console.log('this.ruleForm.storeId', this.ruleForm.storeId)
      if (!this.ruleForm.storeId) {
        this.$message.error('请先验证平台号')
        return
      }
      let params = {
        spuName: queryString,
        storeId: this.ruleForm.storeId
      }
      spuListSpu(params).then(res => {
        console.log('res', res)
        res.data.data.forEach(item => {
          item.value = item.spuName
        })
        cb(res.data.data)
      })
    },
    // 产品名称选择
    handleSelectProd (item) {
      console.log('item', item)
      this.ruleForm.spuId = item.id
      this.ruleForm.startupsSpu = item.startupsSpu
      this.imageList = []
      this.getSpuDetail()
    },
    // 获取商品详情
    async getSpuDetail () {
      await storeSpuQuery({ id: this.ruleForm.spuId, storeId: this.ruleForm.storeId }).then(res => {
        if (res.data.success) {
          // let obj = res.data.data
          // obj.skuGroupList.forEach(skuGroup => {
          //   skuGroup.sampleSkuList.forEach(item => {
          //     item.skuName = item.skuName.slice(0, item.skuName.indexOf('-'))
          //   })
          // })
          this.spuDetail = res.data.data
          console.log('this.spuDetail', this.spuDetail)
          this.imgList = res.data.data.spuImageList
          this.handleData()
          this.$nextTick(_ => {
            this.$forceUpdate()
            if (this.imageList.length < 1) {
              this.previewImg()
            }
          })
        }
      })
    },
    // 计算满减价格(弃用)
    // activityPrice () {
    //   // 满减
    //   let discountActivity = this.spuDetail.discountActivity
    //   // 折扣
    //   let discountPackagePlatform = this.spuDetail.discountPackagePlatform
    //   let price = this.ruleForm.samplePrice
    //   if (discountActivity) {
    //     let activityType = discountActivity.activityType
    //     let rules = discountActivity.rules.sort(function (a, b) {
    //       return b.fullAmount - a.fullAmount
    //     })
    //     // 满N元减N元
    //     if (activityType == 'FULL_AMOUNT') {
    //       price = price * this.ruleForm.quantity
    //       let itemRule = {}
    //       if (rules.length > 0) {
    //         rules.forEach(a => {
    //           if (price == a.fullAmount || price > a.fullAmount) {
    //             itemRule = a
    //             return false
    //           }
    //         })
    //       } else {
    //         itemRule = rules[0]
    //       }
    //     } else {
    //       // 满N件优惠

    //     }
    //   }
    //   if (discountPackagePlatform) {

    //   }
    // },
    // 处理数据
    handleData () {
      let dict = {}
      this.spuDetail.skuGroupList.forEach(item => {
        // 分离产品属性
        item.dickList = {}
        // let arr = item.dictSet.split(';')
        let arr = item.dictIdSet.split(';')
        arr.splice(-1, 1)
        arr.forEach(i => {
          let list = i.split(':')
          this.spuDetail.spuDictList.forEach(key => {
            if (key.id === +list[0]) {
              key.dictList.forEach(value => {
                if (value.id === +list[1]) {
                  item.dickList[key.propKey] = value.propVal
                  if (dict[key.propKey] === undefined) {
                    dict[key.propKey] = []
                    this.ruleForm.dict[key.propKey] = ''
                  }
                  let lock = false
                  dict[key.propKey].forEach(a => {
                    if (a.val === value.propVal) {
                      lock = true
                    }
                  })
                  if (!lock) {
                    dict[key.propKey].push({ val: value.propVal, disabled: false })
                  }
                }
              })
            }
          })
        })
      })
      console.log('dictdictdictdictdict', dict)
      this.spuDetail.dict = dict
      // 如果没有属性，是套系产品
      if (this.isObjectEmpty(this.spuDetail.dict)) {
        this.skuGroup = this.spuDetail.skuGroupList[0]
        return
      }
      // this.P.price = minPage
      this.getAllWay()
      this.$forceUpdate()
    },
    // 判断是否确定了sku组
    verdict () {
      // // 确认所选符合哪一个sku组
      console.log('this.spuDetail.skuGroupList', this.spuDetail.skuGroupList, this.ruleForm)
      let skuGroupId = ''
      this.spuDetail.skuGroupList.forEach(item => {
        console.log(Object.keys(item.dickList).length - 1)
        for (let i = 0; i <= Object.keys(item.dickList).length - 1; i++) {
          console.log('11111', this.ruleForm.dict)
          this.ruleForm.sampleSkuId = ''
          // this.ruleForm.samplePrice = ''
          // this.ruleForm.onlineSamplePrice = ''
          // this.ruleForm.quantity = 0
          // this.ruleForm.payPrice = ''
          if (this.ruleForm.dict[Object.keys(item.dickList)[i]].val !== item.dickList[Object.keys(item.dickList)[i]]) {
            console.log('break', item)
            break
          }
          if (i === Object.keys(item.dickList).length - 1) {
            console.log('itemitemitemitemitem', i, item)
            this.confirmSku = item
            // 婚纱初创平台或者后期,初创产品，样品价格显示初创平台样品价格
            this.ruleForm.samplePrice = ((this.startups == 1 && this.storeType == 'WEDDINGDRESS' && this.ruleForm.startupsSpu) || this.storeType == 'LATERSTAGE') ? item.startupsSamplePrice : this.applyDiscount ? (item.samplePrice * this.applyDiscount).toFixed(2) : item.samplePrice
            // this.ruleForm.payPrice = ((this.startups == 1 && this.storeType == 'WEDDINGDRESS' && this.ruleForm.startupsSpu) || this.storeType == 'LATERSTAGE') ? item.startupsSamplePrice : item.samplePrice
            this.ruleForm.onlineSamplePrice = this.applyDiscount ? (item.onlineSamplePrice * this.applyDiscount).toFixed(2) : item.onlineSamplePrice
            this.ruleForm.quantity = 1
            this.ruleForm.payPrice = (this.ruleForm.samplePrice * this.ruleForm.quantity).toFixed(2)
            if (this.confirmSku.sampleSkuList.length == 1) {
              this.ruleForm.sampleSkuId = this.confirmSku.sampleSkuList[0].id
            }
            skuGroupId = item.id
            console.log('this.ruleForm.samplePrice', this.ruleForm.samplePrice)

            // this.$refs.bigP.changeSkuGroupImg(item.skuGroupImage)
            if (this.ruleForm.sampleSkuId) {
              this.previewImg()
            }
          }
        }
      })
      if (skuGroupId === '') {
        this.confirmSku = {
          sampleSkuList: []
        }
        this.isShow = false
      } else {
        this.isShow = true
        this.ruleForm.isSample = false
      }
    },
    // 添加disabled
    decideDisabled () {
      // 1.除了已选的行先全设为true
      for (let item in this.spuDetail.dict) {
        if (this.ruleForm.dict[item] !== '') {
          continue
        }
        this.spuDetail.dict[item].forEach(dictItem => {
          dictItem.disabled = true
        })
      }
      // 判断能到达的路径将其解除禁用
      this.nowWay.forEach(skuGroup => {
        for (let item in this.spuDetail.dict) {
          this.spuDetail.dict[item].forEach(dictItem => {
            if (skuGroup[item] === dictItem.val) {
              dictItem.disabled = false
            }
          })
        }
      })
    },
    // 筛选
    filterNext (item, i) {
      if (i === this.selectDictKeyList.length - 1) {
        return true
      }
      i++
      return item[this.selectDictKeyList[i]] === this.ruleForm.dict[this.selectDictKeyList[i]].val && this.filterNext(item, i)
    },
    // 筛选出所有满足条件的路径
    filterWay (key) {
      this.selectDictKeyList = []
      for (let item in this.ruleForm.dict) {
        if (this.ruleForm.dict[item] !== '') {
          this.selectDictKeyList.push(item)
        }
      }

      // 摘除一个属性其余属性能否到达
      for (let i = 0; i < this.selectDictKeyList.length; i++) {
        let arr = this.nowWay
      }
      for (let i = 0; i < this.selectDictKeyList.length; i++) {
        this.nowWay = this.nowWay.filter(item => {
          return item[this.selectDictKeyList[i]] === this.ruleForm.dict[this.selectDictKeyList[i]].val
        })
      }
      // 如果没有符合的路径，则清空
      if (this.nowWay.length === 0) {
        this.relieveDisabled(key)
      } else {
        this.decideDisabled()
      }
    },
    // 清除所有选择属性，只当前点击的选中
    clear (key) {
      for (let item in this.ruleForm.dict) {
        if (item !== key) {
          this.ruleForm.dict[item] = ''
        }
      }
      this.nowWay = this.way
      this.filterWay(key)
    },
    // 如果是禁用的按钮先解除所有按钮的禁用
    relieveDisabled (key) {
      for (let item in this.spuDetail.dict) {
        this.spuDetail.dict[item].forEach(dictItem => {
          dictItem.disabled = false
        })
      }
      this.clear(key)
    },
    // 选择属性判定存在该属性sku组有无其他属性，没有则禁用
    change (val, key) {
      console.log(key, this.ruleForm)
      // 判断是不是禁用的按钮
      if (this.ruleForm.dict[key].disabled === true) {
        this.relieveDisabled(key)
      } else {
        this.nowWay = this.way
        this.filterWay(key)
      }
      this.verdict()

      this.$forceUpdate()
    },
    // 选择套系
    changeGroup () {
      this.previewImg()
    },
    // 获取所有路径
    getAllWay () {
      this.way = []
      this.spuDetail.skuGroupList.forEach(item => {
        this.way.push(item.dickList)
      })
      for (let key in this.ruleForm.dict) {
        this.ruleForm.dict[key] = { val: this.way[0][key], disabled: false }
        this.change('', key)
      }
      this.$forceUpdate()
    },
    async showPreviewImg () {
      if (this.imageList.length < 1) {
        await this.previewImg()
      }
      this.imgViewerVisible = true
    },
    // 预览样品图片
    async previewImg () {
      console.log('this.confirmSku', this.confirmSku)
      if (this.confirmSku.sampleSkuList.length < 1) {
        this.$message.error('该产品没有样品主题，请添加')
        return
      }
      let data = this.confirmSku.sampleSkuList.find(a => a.id == this.ruleForm.sampleSkuId)
      console.log('data', data)
      let val = {
        skuGroupId: this.confirmSku.id,
        id: data.themeId
      }
      let res = await previewSampleImage(val)
      console.log('res+++++', res)
      this.imageList = [] // 预览图
      if (res.data.data.length > 0) {
        this.skuListData = res.data.data
        res.data.data.forEach((a, i) => {
          this.skuListData[i].imageList = []
          a.pageTypeVOS.forEach(b => {
            // console.log('b.imageInfos', b.imageInfos)
            b.imageInfos = b.imageInfos.map(c => {
              c.imgDetail = c.imgDetail ? JSON.parse(c.imgDetail) : {}
              return c
            })
            this.imageList = this.imageList.concat(b.imageInfos)
            this.skuListData[i].imageList = this.skuListData[i].imageList.concat(b.imageInfos)
          })
        })
        this.itemImgs.name = this.imageList[0].imageName
        this.itemImgs.index = 1
        console.log('this.skuListData', this.skuListData)
      } else {
        this.itemImgs.name = ''
        this.itemImgs.index = 0
      }
      this.ruleForm.quantity = 1
      this.ruleForm.payPrice = (this.ruleForm.samplePrice * this.ruleForm.quantity).toFixed(2)
    },
    // 轮播图切换
    carouselChange (i) {
      console.log('val', i)
      this.itemImgs.name = this.imageList[i].imageName
      this.itemImgs.index = i + 1
    },
    /* 预览轮播切换 */
    onClickCarousel (type) {
      if (type === 'prev') this.$refs['el-carousel'].prev()
      if (type === 'next') this.$refs['el-carousel'].next()
    },
    // ----------------之前的----------
    async getAllshi () {
      console.log('shishishishishsi')
      if (this.selectAddress.sheng === '') {
        this.selectAddress.shi = ''
        this.selectAddress.qu = ''
        return
      }
      this.address.shi = []
      await addressGetCityByProvinceCode(this.selectAddress.sheng.code).then(res => {
        console.log('获取市')
        if (res.data.success) {
          this.address.shi = res.data.data
          // if (res.data.data.filter(item => { return item.id === this.selectAddress.shi.id }).length === 0) {
          this.selectAddress.shi = this.selectAddress.shi.id ? this.selectAddress.shi : res.data.data[0]
          // this.selectAddress.qu = ''
          console.log('获取区')
          this.getAllQu()
          // }
        }
      })
    },
    getAllQu () {
      console.log('this.selectAddress.shi.id', this.selectAddress.shi.id)
      if (this.selectAddress.shi === '') {
        this.selectAddress.qu = ''
        return
      }
      this.address.qu = []
      addressGetCountyByCityId(this.selectAddress.shi.id).then(res => {
        if (res.data.success) {
          this.address.qu = res.data.data
          // if (res.data.data.filter(item => { return item.id === this.selectAddress.qu.id }).length === 0) {
          this.selectAddress.qu = this.selectAddress.qu.id ? this.selectAddress.qu : res.data.data[0]
          // }
        }
      })
    },
    getAllSheng () {
      this.address.sheng = []
      addressGetAllProvince().then(res => {
        if (res.data.success) {
          this.address.sheng = res.data.data
        }
      })
    },
    addCart () { },
    openSave (type) {
      this.openType = type
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.show) {
            this.$message.error('请验证平台')
            return
          }
          if (JSON.stringify(this.selectAddress.qu.id !== undefined) !== JSON.stringify(this.ruleForm.addressVo.fullAddress !== '')) {
            this.$message.error('请完善地址信息')
            return
          }
          if (JSON.stringify(this.selectAddress.qu.id !== '') !== JSON.stringify(this.ruleForm.addressVo.fullAddress !== '')) {
            this.$message.error('请完善地址信息')
            return
          }
          if (((this.ruleForm.payPrice / this.ruleForm.quantity) < this.ruleForm.samplePrice) && !this.ruleForm.remark) {
            this.$message.error('请填写备注')
            return
          }
          if (this.imageList.length < 1) {
            this.$message.error('当前选择的主题没有预览图片，请先上传图片!')
            return
          }
          // 将已经上传的图片进行校验，防止修改产品信息之前的图片有误
          // let skuList = this.spuDetail.skuGroupList[0].skuList[0].seriesAssociateSkuList
          // this.skuListData.forEach((a, i) => {
          //   this.checkPageSize(i)
          // })
          getByStoreIds(this.ruleForm.storeId).then(res => {
            console.log('reses', res)
            if (res.data.success) {
              this.standbyCreditLine = res.data.data.standbyCreditLine
              this.basicMsg.myBalance = res.data.data.balances.ACCT.balance
              this.basicMsg.balance = parseFloat((this.basicMsg.myBalance - this.ruleForm.payPrice).toFixed(2))
              if (this.openType == 'order') {
                this.dialogVisible = true
              } else {
                this.applySample()
              }
              this.loading = false
            }
          })
        } else {
          return false
        }
      })
    },
    // 校验图片
    checkPageSize (index, files, width, height, xdpi, ydpi, pageType, color, spuDpi, rotate) {
      console.log('pageType', pageType, files, this.defaultSizeGroup)
      // let oneName = files[0].name
      let coverPages = files.filter(a => a.name.includes('封面'))
      let sizeList = this.defaultSizeGroup.sizeList.find(a => a.pageTypeCode == pageType)
      console.log('sizeList-封面-内页', sizeList)
      let sizeHeightError = 0.5
      let sizeWidthError = 0.5
      // 宽高增加出血尺寸
      let newWidth
      // 半P
      if (sizeList.spuPageName.templatePropertyCode === 'HALF_PAGE') {
        newWidth = sizeList.sizeWidth * 2 + sizeList.bleed.bleedLeft + sizeList.bleed.bleedRight
      } else {
        newWidth = sizeList.sizeWidth + sizeList.bleed.bleedLeft + sizeList.bleed.bleedRight
      }
      if (this.spuDetail.specialLayout && (index == coverPages.length || (index == (files.length - 1)))) {
        // 特殊排版校验宽度(首页是封面的时候，校验第二P,首页不是封面的时候，校验第一P,最后一P,是不是传的一半的尺寸)
        width = width * 2
      }
      // 宽高增加出血尺寸
      let newHeight = sizeList.sizeHeight + sizeList.bleed.bleedTop + sizeList.bleed.bleedBottom
      console.log('宽高-----', width, newWidth)
      console.log('高宽++++', height, newHeight)
      // 宽宽，高高相同    宽高，高宽相同
      let w = Math.abs(width - newWidth)
      if (this.spuDetail.specialLayout && (index == coverPages.length || (index == (files.length - 1)))) {
        // 特殊排版，由于宽度*了2，导致误差值翻倍，所以这里误差值要再/2
        w = w / 2
      }
      let h = Math.abs(height - newHeight)
      let wh = Math.abs(width - newHeight)
      let hw = Math.abs(height - newWidth)
      let w1 = sizeWidthError
      let h1 = sizeHeightError
      let error = ''
      let sizeError = (pageType == 'COVER' ? '封面' : pageType == 'SINGLE' ? '单页' : '内页') + '尺寸错误'
      if (!(color === '3' || color === 'RGB' || color === 'RGB with Alpha')) {
        error = '色彩模式应为RGB'
      } else if ((spuDpi === 300 && (+xdpi > 301 || +ydpi > 301)) || (spuDpi === 254 && (+xdpi < 253 || +ydpi < 253))) {
        error = '分辨率错误'
      } else if (newWidth == newHeight) {
        // 新加的：宽高尺寸相同的时候，只要一边大于误差值尺寸就不对
        if (w > w1 || h > h1) {
          error = sizeError
        }
      } else {
        // 旋转角度是90或者270 旋转之后的宽高匹配 (这里倒过来匹配是因为：旋转之后的宽高，获取到的是之前的)
        if (rotate == 90 || rotate == 270) {
          console.log('有角度', rotate)
          if (wh > w1 || hw > h1) {
            // 相框，摆台判断颠倒过来之后的宽高误差值，如果也匹配不上，尺寸错误
            if (this.$route.query.spuType == 'PHOTO_FRAME' || this.$route.query.spuType == 'STAGE') {
              if (w > w1 || h > h1) {
                error = sizeError
              } else {
                error = ''
              }
            } else {
              error = sizeError
            }
          } else {
            error = ''
          }
        } else {
          console.log('没有角度', rotate)
          console.log('w:', w, 'h:', h, 'wh:', wh, 'hw:', hw, 'w1:', w1, 'h1:', h1)
          // 只要宽高有一边匹配不上，相框，摆台再判断宽高颠倒之后的
          if (w > w1 || h > h1) {
            // 相框，摆台判断颠倒过来之后的宽高误差值，如果也匹配不上，尺寸错误
            if (this.$route.query.spuType == 'PHOTO_FRAME' || this.$route.query.spuType == 'STAGE') {
              if (wh > w1 || hw > h1) {
                error = sizeError
              } else {
                error = ''
              }
            } else {
              error = sizeError
            }
          } else {
            error = ''
          }
        }
      }
      return error
    },
    async applySample () {
      // 可以使用授信额度
      let money = this.standbyCreditLine + this.basicMsg.balance
      console.log('money', money)
      if (money < 0) {
        this.$message.error('平台余额不足')
        return
      }
      let userAddressVo = {
        city: this.selectAddress.shi.name,
        cityId: this.selectAddress.shi.id,
        county: this.selectAddress.qu.name,
        countyId: this.selectAddress.qu.id,
        province: this.selectAddress.sheng.name,
        provinceCode: this.selectAddress.sheng.code,
        fullAddress: this.ruleForm.addressVo.fullAddress,
        person: this.ruleForm.person,
        phone: this.ruleForm.phone
      }
      this.loading = true
      await saveUserAddress(userAddressVo).then(async res => {
        if (res.data.success) {
          let addressDetail = res.data.data
          this.orderData = {
            // agentId: 0,
            channel: 'B2B',
            originType: (this.storeType == 'WEDDINGDRESS' || this.storeType == 'LATERSTAGE') ? 'BRIDAL' : this.storeType == 'ALBUM' ? 'VIDEO' : 'WEB',
            orderRemark: this.ruleForm.remark,
            skuMoney: this.ruleForm.samplePrice,
            payMoney: this.ruleForm.payPrice,
            onlinePriceTotal: this.ruleForm.onlineSamplePrice,
            spus: [],
            storeId: this.ruleForm.storeId
          }
          let skuId = ''
          // 套系
          if (this.isObjectEmpty(this.spuDetail.dict) && this.spuDetail.skuGroupList) {
            skuId = this.confirmSku.skuList[0].id
          } else { // 其他
            skuId = this.confirmSku.skuList.find(a => a.id == this.skuId)
          }
          let obj = {}
          if (this.openType == 'order') {
            obj = {
              addressId: addressDetail.id,
              memo: '',
              normal: false,
              quantity: this.ruleForm.quantity,
              sample: true,
              skuGroupId: this.confirmSku.id,
              skuId: skuId,
              spuId: this.confirmSku.spuId,
              series: false,
              skus: []
            }
          } else {
            let dataTheme = this.confirmSku.sampleSkuList.find(a => a.id == this.ruleForm.sampleSkuId)
            console.log('样品', dataTheme)
            obj = {
              sampleThemeId: dataTheme.themeId,
              sampleThemeName: dataTheme.skuName,
              addressId: addressDetail.id,
              directorId: '',
              folderName: '',
              memo: this.ruleForm.person,
              price: null,
              quantity: this.ruleForm.quantity,
              remark: this.ruleForm.remark,
              samplePrice: this.ruleForm.samplePrice,
              // sampleRealPrice: (this.ruleForm.payPrice / this.ruleForm.quantity).toFixed(2),
              sampleRealPrice: this.ruleForm.payPrice,
              sampleOnlinePriceTotal: this.ruleForm.onlineSamplePrice,
              shareId: null,
              skus: [],
              spuId: this.confirmSku.spuId,
              sampleStoreId: this.ruleForm.storeId
            }
          }
          console.log('this.confirmSku', this.confirmSku)
          let skuNum = 0
          for (let k in this.skuListData) {
            let item = this.skuListData[k]
            console.log(' item.imageList', item.imageList)
            let imageList = item.imageList.filter(a => !a.imageName.includes('封面'))
            let skuObj = {}
            if (this.openType == 'order') {
              skuObj = {
                page: imageList.length,
                skuId: item.associationSkuId,
                weight: item.weight || '',
                spuId: this.confirmSku.spuId,
                url: '',
                orderItemType: 'SALE_SAMPLE'
              }
            } else {
              skuObj = {
                page: imageList.length,
                skuId: item.associationSkuId,
                spuId: this.confirmSku.spuId,
                images: [{
                  url: ''
                }]
              }
            }
            let jsonObj = {
              skuId: item.associationSkuId,
              image: []
            }
            item.imageList.forEach((img, i) => {
              jsonObj.image.push({
                name: img.id,
                sequence: i,
                // sort: img.sort,
                type: img.pageTypeCode,
                url: img.imageUrl,
                rotate: img.rotate,
                specialLayout: img.specialLayout,
                specialLayoutWhitePagePosition: img.specialLayoutWhitePagePosition ? img.specialLayoutWhitePagePosition : null
              })
            })
            // 为了拦截图片因网络等特殊原因加载失败 
            let haveNoUrl = jsonObj.image.find(a => !a.url)
            // 存在url是空的时候
            if (haveNoUrl) {
              this.$notify({
                title: '失败',
                message: '图片加载失败，请刷新页面重新提交或者联系管理员',
                type: 'error'
              })
              return
            }
            console.log('jsonObj', jsonObj)
            await uploadStr(JSON.stringify(jsonObj), this.$store.state.awsSdk.special.s3).then(async res => {
              console.log('resssss', res)
              if (res === 'error') {
                this.$notify({
                  title: '失败',
                  message: '服务器问题，请刷新页面重试或联系管理员',
                  type: 'error'
                })
                return
              }
              if (this.openType == 'order') {
                skuObj.url = res
              } else {
                skuObj.images[0].url = res
              }
              obj.skus.push(skuObj)
              skuNum++
              if (skuNum === this.skuListData.length) {
                this.orderData.spus.push(obj)
                this.orderData.originType = (this.storeType == 'WEDDINGDRESS' || this.storeType == 'LATERSTAGE') ? 'BRIDAL' : this.storeType == 'ALBUM' ? 'VIDEO' : 'WEB'
                // if (this.orderData.spus.length === this.selectList.length) {
                // 提交订单
                if (this.openType == 'order') {
                  await orderNow(this.orderData).then(res => {
                    this.uploading = false
                    if (res.data.success) {
                      // this.$refs.loading.hide()
                      this.$notify({
                        title: '成功',
                        message: '已提交订单',
                        type: 'success'
                      })
                      this.dialogVisible = false
                      // this.dropLength = 0
                      // this.$store.dispatch('user/getCart')
                      if (this.storeType == 'WEDDINGDRESS' || this.storeType == 'LATERSTAGE') {
                        this.$router.push({ path: '/orderHs' })
                      } else if (this.storeType == 'ALBUM') {
                        this.$router.push({ path: '/orderYxj' })
                      } else {
                        this.$router.push({ path: '/order' })
                      }
                    }
                  })
                } else {
                  let cartData = {
                    channel: 'B2B',
                    originType: (this.storeType == 'WEDDINGDRESS' || this.storeType == 'LATERSTAGE') ? 'BRIDAL' : this.storeType == 'ALBUM' ? 'VIDEO' : 'WEB',
                    itemType: 'SALE_SAMPLE',
                    normal: false,
                    sample: true,
                    series: false,
                    skuGroupId: this.confirmSku.id,
                    skuId: skuId,
                    spuId: this.confirmSku.spuId,
                    storeId: this.ruleForm.storeId,
                    spus: this.orderData.spus
                  }
                  cartItemSpu(cartData).then(res => {
                    if (res.data.success) {
                      this.$notify({
                        title: '成功',
                        message: this.$createElement('p', {}, [
                          '商品已添加到购物车,',
                          this.$createElement(
                            'span',
                            {
                              class: 'color-blue',
                              on: {
                                click: () => {
                                  this.$router.push('/cart')
                                }
                              }
                            },
                            '点击进入购物车'
                          )
                        ]),
                        type: 'success'
                      })
                      this.dialogVisible = false
                      // // 清空表单数据
                      // this.$refs.ruleForm.resetFields()
                      // this.ruleForm.quantity = 0
                      // this.ruleForm.payPrice = ''
                      // this.ruleForm.remark = ''
                      // this.imageList = []
                      // this.skuListData = []
                      // this.confirmSku.sampleSkuList = []
                      // 刷新页面
                      setTimeout(() => {
                        this.$router.go(0)
                      }, 500)
                    }
                  })
                }
                // }
              }
            })
          }
        }
        this.loading = false
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";

/deep/.el-autocomplete {
  .el-input {
    width: 250px !important;
  }
}
</style>
<style>
.el-autocomplete-suggestion {
  width: auto !important;
}
</style>
